import { growthbook } from 'src/pages/_app';
import ErrorBoundary from '../components/layouts/errorBoundary';
import { Components } from './components';
import { getFeatures } from './features';
import { useUserInfoStore } from '@/modules/login/store/userInfo';

interface FragmentProps {
  name: string;
  variants?: Record<string, any>;
  props?: Record<string, any>;
}

export const Fragment = ({ name, variants, props }: FragmentProps) => {
  const user_id = useUserInfoStore(state => state.info.id);

  if (!name) return null;
  const features = getFeatures({ provider: growthbook });

  const entry = Components[name];
  if (!entry) {
    return (
      <ErrorBoundary>
        <p>Error</p>
      </ErrorBoundary>
    );
  }
  const { Component, id, projectId } = entry;
  // The allowed-props filter runs inside the lazy chunk (withAllowedProps), see components.tsx.
  return (
    <ErrorBoundary>
      <Component
        data-fragment-component-id={id}
        data-fragment-project-id={projectId}
        data-fragment-component={name}
        fragmentInput={{ props: { ...props, ...features }, variants }}
      />
    </ErrorBoundary>
  );
};

export default Fragment;

